/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_HeadingInputs */

const tr_iade_iptal_s11_heading = /** @type {(inputs: Iade_Iptal_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Abonelik Sonrası Erişim ve Veri Talepleri`)
};

const en_iade_iptal_s11_heading = /** @type {(inputs: Iade_Iptal_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Access and Data Requests after Subscription Expiry`)
};

const de_iade_iptal_s11_heading = /** @type {(inputs: Iade_Iptal_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Zugang und Datenanfragen nach dem Abo-Ende`)
};

const ru_iade_iptal_s11_heading = /** @type {(inputs: Iade_Iptal_S11_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11. Доступ и Запросы Данных после Окончания Подписки`)
};

/**
* | output |
* | --- |
* | "11. Access and Data Requests after Subscription Expiry" |
*
* @param {Iade_Iptal_S11_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_heading = /** @type {((inputs?: Iade_Iptal_S11_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_heading(inputs)
	if (locale === "de") return de_iade_iptal_s11_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_heading(inputs)
	return tr_iade_iptal_s11_heading(inputs)
});